var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.968,
    height: 10.203,
    viewBox: "0 0 12.968 10.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contacts",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_8",
    "data-name": "Line 8",
    d: "M8.17.182h-8.5A.516.516,0,0,1-.85-.334.516.516,0,0,1-.334-.85h8.5a.516.516,0,0,1,.516.516A.516.516,0,0,1,8.17.182Z",
    transform: "translate(4.281 1.245)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_9",
    "data-name": "Line 9",
    d: "M8.17.182h-8.5A.516.516,0,0,1-.85-.334.516.516,0,0,1-.334-.85h8.5a.516.516,0,0,1,.516.516A.516.516,0,0,1,8.17.182Z",
    transform: "translate(4.281 5.496)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_10",
    "data-name": "Line 10",
    d: "M8.17.182h-8.5A.516.516,0,0,1-.85-.334.516.516,0,0,1-.334-.85h8.5a.516.516,0,0,1,.516.516A.516.516,0,0,1,8.17.182Z",
    transform: "translate(4.281 9.748)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 0.85,
    cy: 0.85,
    r: 0.85,
    transform: "translate(0 0)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 0.85,
    cy: 0.85,
    r: 0.85,
    transform: "translate(0 4.251)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 0.85,
    cy: 0.85,
    r: 0.85,
    transform: "translate(0 8.503)",
    fill: "#a5a5a5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts10);
export default __webpack_public_path__ + "static/media/Contacts10.b4a128401b195b7916ebaaaf6f936bfa.svg";
export { ForwardRef as ReactComponent };